<template>
  <div v-show="visible" class="wrapper">
    <youtube
      :playerVars="{ autoplay: 0, controls: 0, showinfo: 0, rel: 0 }"
      @ready="ready"
      @pause="pause"
      @playing="playing"
    />
  </div>
</template>

<script lang="">
import { mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters('video/youtube', [
      'visible'
    ])
  },
  methods: {
    ready (player) {
      this.setPlayer(player)
      player.setSize(1920, 1080)
    },
    playing (player) {
      console.log('playe youtube')
    },
    pause () {},
    ...mapMutations('video/youtube', [
      'setPlayer'
    ])
  }
}
</script>

<style scoped>
.wrapper {
  position : absolute;
  top      : 0;
  left     : 0;
  z-index  : 2;
}
</style>



// WEBPACK FOOTER //
// src/components/video/content/youtube.vue